import axiosInstance from "../utils/axiosConfig";

// --------------------------------------------------
// RÉCUPÉRER LA CLÉ PUBLIQUE CLOUDFLARE TURNSTILE
// --------------------------------------------------

export const getTurnstileConfig = async () => {
    const response = await axiosInstance.get("/turnstile/config");

    return response.data;
};

// --------------------------------------------------
// ENVOYER UN MESSAGE GÉNÉRAL
// --------------------------------------------------

export const postContactGeneral = async (lastname, firstname, email, content, captchaToken) => {
    try {
        const response = await axiosInstance.post("/messages/contact/general", {
            lastname,
            firstname,
            email,
            content,
            captchaToken,
        });

        return response.data;
    } catch (error) {
        console.error("Error posting general message:", error);
        throw error;
    }
};

// --------------------------------------------------
// ENVOYER UN MESSAGE ENTREPRISE / ÉVÉNEMENT
// --------------------------------------------------

export const postContactEntreprise = async (lastname, firstname, company, email, nb_pizza, date, hour, content, captchaToken) => {
    try {
        const response = await axiosInstance.post("/messages/contact/entreprise", {
            lastname,
            firstname,
            company,
            email,
            nb_pizza,
            date,
            hour,
            content,
            captchaToken,
        });

        return response.data;
    } catch (error) {
        console.error("Error posting entreprise message:", error);
        throw error;
    }
};
